/**
 * <LastReportCard> — « Dernier bilan » on the parent home (organism).
 *
 * The same report as a card of the Rapports tab, told the same way: `<LiveReportHeader size="sm">`
 * (chapter chips, the tutor's capsule, date · time · tutor, and the engagement ring — smaller here),
 * then the tutor's own words clamped to three lines. The WHOLE card opens the report; the chevron
 * says so, and there is no second link.
 *
 * Unlike `<LiveReportCard>` (the Rapports tab), this one takes its width from the flow — the
 * home puts it in a column that is half the page on a wide screen.
 *
 * **L'aurore des champions** (V16) : Zoé a résumé ce bilan, donc la carte porte l'aurore
 * (`<AuroraFill>`) sur sa surface blanche — nuit en sombre. C'est la seule carte de rapport qui la
 * porte : l'aurore est le temps fort de l'accueil, pas un habit de la liste.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Icon } from "../../atoms/icons/Icon"
import { Text } from "../../atoms/typography/Text"
import { AuroraFill } from "../../molecules/AuroraFill"
import { Card } from "../../molecules/Card"
import { LiveReportHeader } from "../../molecules/LiveReportHeader"
import { type UIParentLastReport } from "../../../ports/primary/ui/types"

export type LastReportCardProps = {
    report: UIParentLastReport
    onPress?: () => void
    testID?: string
}

export function LastReportCard(props: LastReportCardProps) {
    const { report, onPress, testID } = props

    return (
        <Card pressable={onPress != null} onPress={onPress} p="4" testID={testID}>
            <AuroraFill />
            <Row gap="3" align="center">
                <Stack gap="3" style={styles.body}>
                    <LiveReportHeader report={report} size="sm" />
                    <Text size="text-lg" numberOfLines={3}>
                        « {report.comment} »
                    </Text>
                </Stack>

                {onPress != null && <Icon name="chevron-right" size={20} color="text-muted" />}
            </Row>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    body: {
        flex: 1,
        flexShrink: 1,
    },
}))
